import { HOST } from "consts/env";
import { FetchManager } from "services/FetchManager";
import { LanguageType } from "stores/useLocaleStore";
import { APIResponse } from "types/api";
import { Language } from "types/language";
import { devLog, Util } from "utils";
import { create } from "zustand";

interface APIType {
  getLanguages: () => Promise<APIResponse<{ resultList: LanguageType[] }>>;
  changeLanguage: (form: { userId: string; languageCode: Language }) => Promise<
    APIResponse<{
      resultObject: {
        access_TOKEN: string;
        languageCode: Language;
        userId: string;
      };
    }>
  >;
}

const useAPIStore = create<APIType>(() => ({
  async getLanguages() {
    try {
      let url = `${HOST}/languages`;
      const res = await FetchManager.get(url);
      const data = await Util.fetchAndSetData(res);

      if (data) return data;
      else throw new Error();
    } catch (e) {
      devLog("[getLanguages] 오류 발생", e);
      return false;
    }
  },
  async changeLanguage(form) {
    try {
      let url = `${HOST}/languages`;
      const res = await FetchManager.post(url, form);
      const data = await Util.fetchAndSetData(res);

      if (data) return data;
      else throw new Error();
    } catch (e) {
      devLog("[changeLanguage] 오류 발생", e);
      return false;
    }
  },
}));

export default useAPIStore;
